<template>
  <div class="priceManagement-page">
    <div class="all-content-container">
      <div class="screen-all-container">
        <el-tabs v-model="activeName" class="el-tab_top">
          <!-- <el-tab-pane label="作物生长模型" name="first">

          </el-tab-pane>
          <el-tab-pane label="光合作用模型" name="three" v-if="userType == 3&&!show">
            <planManagement></planManagement>
          </el-tab-pane>
          <el-tab-pane label="大棚环境模型" name="second">
          </el-tab-pane>
          <el-tab-pane label="大棚调控设备" name="six" v-if="userType != 3&&!show">
            <growthModelDeviceControlManagement></growthModelDeviceControlManagement>
          </el-tab-pane>
          <el-tab-pane label="大棚告警配置" name="four" v-if="userType != 3&&!show">
            <groupAlarmManagement></groupAlarmManagement>
          </el-tab-pane>
          <el-tab-pane label="大棚告警记录" name="five" v-if="userType != 3&&!show">
            <groupAlarmHisAlarm></groupAlarmHisAlarm>
          </el-tab-pane> -->
          <el-tab-pane label="农事记录" name="first">
            <groupFarm></groupFarm>
          </el-tab-pane>
          <el-tab-pane label="农事计划" name="second">
            <farmingReminder></farmingReminder>
          </el-tab-pane>
          <el-tab-pane label="收益记录" name="thrid">
            <incomeRecord></incomeRecord>
          </el-tab-pane>
          <el-tab-pane label="价格记录" name="fourth">
            <Pricerecord></Pricerecord>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import groupFarm from '../groupAlarm/groupFarm1'
import farmingReminder from '../groupAlarm/farmingReminder'
import incomeRecord from '../groupAlarm/incomeRecord'
import Pricerecord from '../groupAlarm/pricerecord'

export default {
  components: {
    groupFarm,
    farmingReminder,
    incomeRecord,
    Pricerecord
  },
  data() {
    return {
      activeName: 'first',
      userType: 0, // 用户类型（-1 超级管理员，0管理员，1测试用户，2普通用户，3专家用户）
      show: false
    }
  },
  created() {
    this.userType = sessionStorage.getItem('USER_Type')
  },
  methods: {
    handleSelect() {}
  }
}
</script>
<style scoped>
@import '../../style/userManagement.scss';
</style>
